import { APP_MOUNTED_EVENT } from '~/utils/legacyBrowserFallbackSignal'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    document.dispatchEvent(new Event(APP_MOUNTED_EVENT))
  })
})
